export const isLocalhost = ()=>{
    const location_host = window.location.hostname;
    return location_host.includes('localhost');
};
export const getDevEnv = ()=>{
    const isLocal = isLocalhost() || window.location.hostname.includes('orbits.run') || window.location.hostname.includes('ngrok.io');
    const isCypress = window.Cypress;
    return {
        isLocal,
        isCypress
    };
};
